import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Footer } from './Footer';
import * as S from './styles';

interface DrawerProps {
	open?: boolean;
	loading?: boolean;
	edition?: boolean;
	children: JSX.Element;
	footer?: JSX.Element;
	onSubmit: () => void;
	onCancel: () => void;
	onClose?: () => void;
}

export function Drawer({
	open = false,
	loading = false,
	edition = false,
	children,
	onSubmit,
	onCancel,
	onClose
}: Readonly<DrawerProps>): JSX.Element {
	const titleText: string = edition ? 'Edit action plan' : 'Create action plan';

	return (
		<S.Container
			open={open}
			destroyOnClose
			title={I18n.get(titleText)}
			footer={<Footer loading={loading} edition={edition} onSubmit={onSubmit} onCancel={onCancel} />}
			onClose={onClose}
		>
			{children}
		</S.Container>
	);
}
